import React, { useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Intro from './components/Intro';
import Expertise from './components/Expertise';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Education from './components/Education';
import Profiles from './components/Profiles';
// import Portfolio from './components/Portfolio';
import Awards from './components/Awards';
import Footer from './components/Footer';
import ScrollReveal from 'scrollreveal';

// API-ready page model. For now each section still uses local defaults when this object is empty.
const resumeData = {
  // header: {...},
  // intro: {...},
  // expertise: {...},
  // skills: {...},
  // experience: {...},
  // education: {...},
  // profiles: {...},
  // awards: {...},
  // portfolio: {...},
  // clients: {...},
  // footer: {...}
};

function App() {
  useEffect(() => {
    ScrollReveal().reveal('.a-header', {
      duration: 1000,
      distance: '30px',
      origin: 'bottom',
      delay: 200
    });

    ScrollReveal().reveal('.o-section__heading', {
      duration: 1000,
      distance: '30px',
      origin: 'top',
      delay: 100
    });

    ScrollReveal().reveal('.o-content__body', {
      duration: 1000,
      distance: '30px',
      origin: 'bottom',
      delay: 300
    });
  }, []);

  return (
    <div className="App">
      <div className="c-preloader js-preloader">
        <div className="c-preloader__spinner t-preloader__spinner"></div>
      </div>
      <div className="c-main-container js-main-container">
        <Header data={resumeData.header} />
        <Intro data={resumeData.intro} />
        <Expertise data={resumeData.expertise} />
        <Skills data={resumeData.skills} />
        <Experience data={resumeData.experience} />
        <Education data={resumeData.education} />
        <Profiles data={resumeData.profiles} />
        <Awards data={resumeData.awards} />
        {/* <Portfolio data={resumeData.portfolio} /> */}
        {/* <Clients data={resumeData.clients} /> */}
        <Footer data={resumeData.footer} />
      </div>
    </div>
  );
}

export default App;
